export const ONBOARDING = "Onboarding"
export const SUPERVISOR = "Supervisor"
export const USERADMIN = "UserAdmin"
export const CUSTOMERADMIN = "CustomerAdmin"
export const USER = "User"     